import React from 'react';
import { CircularProgress, Grid } from '@mui/material';

const FullPageLoader: React.FC<{ height?: string }> = ({ height }) => (
  <Grid
    container
    justifyContent={'center'}
    alignItems={'center'}
    sx={{ height: height || 'calc(100vh - 63px)', width: '100%' }}
  >
    <CircularProgress color='secondary' />
  </Grid>
);

export default FullPageLoader;
